(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('AlertsController', AlertsController);

    AlertsController.$inject = ['$state', 'Alert', 'Subscription', 'Search', 'Principal', 'User'];

    function AlertsController($state, Alert, Subscription, Search, Principal, User) {
        var vm = this;

        vm.alerts = [];
        vm.subscriptions = [];
        vm.query = '';
        vm.noResults = false;
        vm.alertMgmtIsOpen = false;
        vm.emailFrequency = 'weekly';
        vm.me = {};

        vm.search = search;
        vm.markAlertAsSeen = markAlertAsSeen;
        vm.seenFilter = seenFilter;
        vm.removeSubscription = removeSubscription;
        vm.toggleAlertMgmt = toggleAlertMgmt;
        vm.updatePreferences = updatePreferences;

        Alert.query(onAlertFetchCompleted);
        Subscription.query(onSubscriptionFetchCompleted);
        Principal.identity().then(onIdentityRetrieved);

        function onAlertFetchCompleted(alerts) {
            vm.alerts = alerts;
            
            vm.alerts = vm.alerts.map(buildAlertMessage);
        }

        function onSubscriptionFetchCompleted(subscriptions) {
            vm.subscriptions = subscriptions;
        }

        function onIdentityRetrieved(me) {
            vm.me = me;
        }

        function removeSubscription(subscriptionId) {
            Subscription.remove({id: subscriptionId}, function () {
                $state.reload();
            });
        }

        function markAlertAsSeen(alert) {
            alert.seen = true;
            Alert.update(alert, function () {
                $state.reload();
            });
        }

        function seenFilter(alert) {
            return alert.seen === false;
        }

        function search(q) {
            return Search.query(q).then(reshapeQueryResults);
        }

        function toggleAlertMgmt() {
            vm.alertMgmtIsOpen = !vm.alertMgmtIsOpen;
        }

        function updatePreferences() {
            User.update(vm.me, function () {
                $state.reload();
            });
        }

        function buildAlertMessage(alert) {
            switch (alert.type) {
                case 'profile':
                    alert.message = "Le profil de " + alert.profile.firstName + " " +
                        alert.profile.lastName + " a été modifié";
                    if (alert.modification.field === "job") {
                        alert.submessage = "Fonction : " + alert.modification.value;
                    }
                    break;
                case 'organisation':
                    alert.message = "La page de " + alert.organisation.name + " a été modifiée";
                    break;
            }
            return alert;
        }

        function reshapeQueryResults(response) {
            var data = response.data;
            var collectivities = data.collectivities.map(function (el) {
                el.dropdownType = 'company';
                return el;
            });
            var companies = data.companies.map(function (el) {
                el.dropdownType = 'company';
                return el;
            });
            var profiles1 = data.profiles['1'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles2 = data.profiles['2'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            var profiles3 = data.profiles['3'].map(function (el) {
                el.name = el.firstName + ' ' + el.lastName;
                el.dropdownType = 'profile';
                return el;
            });
            collectivities = collectivities.filter(organisationNotInSubscription);
            companies = companies.filter(organisationNotInSubscription);
            profiles1 = profiles1.filter(profileNotInSubscription);
            profiles2 = profiles2.filter(profileNotInSubscription);
            profiles3 = profiles3.filter(profileNotInSubscription);
            var res = companies.splice(0, 2)
                .concat(collectivities.splice(0, 2))
                .concat(profiles1.splice(0, 3))
                .concat(profiles2.splice(0, 2))
                .concat(profiles3.splice(0, 2));

            function profileNotInSubscription(obj) {
                var res = true;
                vm.subscriptions.forEach(function (subscription) {
                    if (subscription.type === "profile") {
                        if (subscription.profile.id === obj.id) {
                            res = false;
                        }
                    }
                });
                return res;
            }

            function organisationNotInSubscription(obj) {
                var res = true;
                vm.subscriptions.forEach(function (subscription) {
                    if (subscription.type === "organisation") {
                        if (subscription.organisation.id === obj.id) {
                            res = false;
                        }
                    }
                });
                return res;
            }

            return res;
        }
    }
})();
